<template>
  <div>
    <h-btn color="primary" flat @click="display=true">Add Question</h-btn>
    <question-modal v-if="display" :dimensions="dimensions" :question="question" @save="save" :error="error" @close="reset" :editable="true" />
  </div>
</template>

<script>
import questionModal from "./questionModal";
import dataStore from "@/services/api/store";
const PULSE_SURVEY_QUESTION_STORE = "CoachPulseSurveyQuestions";

export default {
  props: ["dimensions", "pulseSurvey"],
  components: {
    questionModal
  },
  data() {
    return {
      display: false,
      question: {},
      error: ""
    };
  },
  methods: {
    save() {
      this.question.pulse_survey = this.pulseSurvey;
      dataStore
        .create(PULSE_SURVEY_QUESTION_STORE, this.question)
        .then(question => {
          this.$emit("created", question);
          this.reset();
        })
        .catch(() => {
          this.error =
            "Something went wrong. Our staff has been notified. Please try again later";
        });
    },
    reset() {
      this.question = {};
      this.display = false;
    }
  }
};
</script>

<style>
</style>
